import React, { useEffect, useState } from "react";
import {
  FormWrapper,
  Label,
  Select,
  Button,
  Input,
} from "./shared_form_styles";
import { useDispatch, useSelector } from "react-redux";
import {
  getTuitionValues,
  addTuitionValues,
  updateTuitionValues,
} from "../actions/tuitionValuesActions";

export const SetTuitionValues = ({ closePopup }) => {
  const dispatch = useDispatch();
  const tuitionValues = useSelector((state) => state.tuitionValues || []);
  const [singleSubjectPrice, setSingleSubjectPrice] = useState("");
  const [twoSubjectPrice, setTwoSubjectPrice] = useState("");
  const [threeSubjectPrice, setThreeSubjectPrice] = useState("");
  const [fourSubjectPrice, setFourSubjectPrice] = useState("");
  const [specialSubjectPrice, setSpecialSubjectPrice] = useState("");
  const [enrollmentFee, setEnrollmentFee] = useState("");

  const [currency, setCurrency] = useState("UYU");
  const currencies = ["UYU", "ARG", "USD"];

  useEffect(() => {
    if (tuitionValues.length == 0) {
      dispatch(getTuitionValues());
    }
  }, []);

  useEffect(() => {
    const tuitionValueOfCurrency = tuitionValues.find(
      (tuit) => tuit.currency === currency
    );
    if (tuitionValueOfCurrency) {
      setSingleSubjectPrice(tuitionValueOfCurrency.values["1"]);
      setTwoSubjectPrice(tuitionValueOfCurrency.values["2"]);
      setThreeSubjectPrice(tuitionValueOfCurrency.values["3"]);
      setFourSubjectPrice(tuitionValueOfCurrency.values["4"]);
      setSpecialSubjectPrice(
        tuitionValueOfCurrency.values["special"] ?
          tuitionValueOfCurrency.values["special"]
        : 0
      );
      setEnrollmentFee(tuitionValueOfCurrency.values["enrollmentFee"]);
    } else {
      setSingleSubjectPrice(0);
      setTwoSubjectPrice(0);
      setThreeSubjectPrice(0);
      setFourSubjectPrice(0);
      setSpecialSubjectPrice(0);
      setEnrollmentFee(0);
    }
  }, [tuitionValues, currency]);

  const handleSave = async () => {
    const values = {
      1: parseFloat(singleSubjectPrice),
      2: parseFloat(twoSubjectPrice),
      3: parseFloat(threeSubjectPrice),
      4: parseFloat(fourSubjectPrice),
      special: parseFloat(specialSubjectPrice),
      enrollmentFee: parseFloat(enrollmentFee),
    };
    const tuitionValue = { values: values, currency: currency };
    if (!tuitionValues.some((tuit) => tuit.currency === currency)) {
      await dispatch(addTuitionValues(tuitionValue));
    } else {
      await dispatch(updateTuitionValues(tuitionValue));
    }
    // // Refresh tuition values after save
    // dispatch(getTuitionValues());
  };

  return (
    <FormWrapper>
      <Label>
        Currency:
        <Select value={currency} onChange={(e) => setCurrency(e.target.value)}>
          {currencies.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </Select>
      </Label>
      <Label>
        1 subject:
        <Input
          type="text"
          name="singleSubjectPrice"
          value={singleSubjectPrice}
          placeholder="0"
          onChange={(e) => setSingleSubjectPrice(e.target.value)}
        />
      </Label>
      <Label>
        2 subjects:
        <Input
          type="text"
          name="twoSubjectPrice"
          value={twoSubjectPrice}
          placeholder="0"
          onChange={(e) => setTwoSubjectPrice(e.target.value)}
        />
      </Label>
      <Label>
        3 subjects:
        <Input
          type="text"
          name="threeSubjectPrice"
          value={threeSubjectPrice}
          placeholder="0"
          onChange={(e) => setThreeSubjectPrice(e.target.value)}
        />
      </Label>
      <Label>
        4 subjects:
        <Input
          type="text"
          name="fourSubjectPrice"
          value={fourSubjectPrice}
          placeholder="0"
          onChange={(e) => setFourSubjectPrice(e.target.value)}
        />
      </Label>
      <Label>
        Special Subjects:
        <Input
          type="text"
          name="specialSubjectPrice"
          value={specialSubjectPrice}
          placeholder="0"
          onChange={(e) => setSpecialSubjectPrice(e.target.value)}
        />
      </Label>
      <Label>
        Enrollment Fee:
        <Input
          type="text"
          name="enrollmentFee"
          value={enrollmentFee}
          placeholder="0"
          onChange={(e) => setEnrollmentFee(e.target.value)}
        />
      </Label>
      <Button onClick={handleSave}>Save</Button>
    </FormWrapper>
  );
};

export default SetTuitionValues;
